module.exports = __webpack_public_path__ + "static/img/profile.bc08627.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile.jpeg
// module id = lhV4
// module chunks = 1